const cityOptions = [
  "中国嘉德1","北京匡时1","华艺国际1","北京保利1","北京歌德1","香港邦瀚斯1","德国纳高1","长风拍卖1","北京诚轩1","北京传是1",
  "中国嘉德2","北京匡时2","华艺国际2","北京保利2","北京歌德2","香港邦瀚斯2","德国纳高2","长风拍卖2","北京诚轩2","北京传是2",
  "中国嘉德3","北京匡时3","华艺国际3","北京保利3","北京歌德3","香港邦瀚斯3","德国纳高3","长风拍卖3","北京诚轩3","北京传是3",
  "中国嘉德4","北京匡时4","华艺国际4","北京保利4","北京歌德4","香港邦瀚斯4","德国纳高4","长风拍卖4","北京诚轩4","北京传是4",
  "中国嘉德5","北京匡时5","华艺国际5","北京保利5","北京歌德5","香港邦瀚斯5","德国纳高5","长风拍卖5","北京诚轩5","北京传是5",
  "中国嘉德6","北京匡时6","华艺国际6","北京保利6","北京歌德6","香港邦瀚斯6","德国纳高6","长风拍卖6","北京诚轩6","北京传是6",
  "中国嘉德7","北京匡时7","华艺国际7","北京保利7","北京歌德7","香港邦瀚斯7","德国纳高7","长风拍卖7","北京诚轩7","北京传是7",
  "中国嘉德8","北京匡时8","华艺国际8","北京保利8","北京歌德8","香港邦瀚斯8","德国纳高8","长风拍卖8","北京诚轩8","北京传是8",
  "中国嘉德9","北京匡时9","华艺国际9","北京保利9","北京歌德9","香港邦瀚斯9","德国纳高9","长风拍卖9","北京诚轩9","北京传是9",
  "中国嘉德10","北京匡时10","华艺国际10","北京保利10","北京歌德10","香港邦瀚斯10","德国纳高10","长风拍卖10","北京诚轩10","北京传是10",
];

const options = [
  {
    value: '中国书画',
    label: '中国书画'
  }, {
    value: '古籍善本',
    label: '古籍善本'
  }, {
    value: '西画雕塑',
    label: '西画雕塑'
  }, {
    value: '陶瓷',
    label: '陶瓷'
  }, {
    value: '玉石器',
    label: '玉石器'
  }, {
    value: '鼻烟壶',
    label: '鼻烟壶'
  }, {
    value: '佛教文物',
    label: '佛教文物'
  }, {
    value: '竹木牙角器',
    label: '竹木牙角器'
  }, {
    value: '古典家具',
    label: '古典家具'
  }, {
    value: '珠宝翡翠',
    label: '珠宝翡翠'
  }, {
    value: '邮品钱币',
    label: '邮品钱币'
  }, {
    value: '工艺品杂项',
    label: '工艺品杂项'
  }
]

export { cityOptions, options }